import React, { Component } from 'react';

import TopNav from '../../components/Layout/TopNav';

class VersionHome extends Component {
    render() {
        return (
            <div class="swallow_app">
                <TopNav history={this.props.history} />
                <h2>Version Home</h2>
            </div>
        );
    }
}

export default VersionHome;